module.exports = __webpack_public_path__ + "img/wire-1.ec89ae2f.jpg";